import React from 'react';

import { StyledSortArrow, StyledSortArrowDown, StyledSortArrowUp } from './styled';

type Props = {
  canSort: boolean;
  isSorted: boolean;
  isSortedDesc?: boolean;
};

const HeaderSortPart = ({ canSort, isSortedDesc, isSorted }: Props): JSX.Element | null => {
  if (!canSort) return null;
  if (!isSorted) return <StyledSortArrow data-testid="sortArrow" />;
  return isSortedDesc ? <StyledSortArrowUp data-testid="arrowUp" /> : <StyledSortArrowDown data-testid="arrowDown" />;
};

export default HeaderSortPart;
